// extracted by mini-css-extract-plugin
export default {"dualFlags":"_Go6knMRBpUt6cPf2OdG","primaryFlag":"xpLQkW_deHpkdQaPofIj","secondaryFlag":"d0HA6HWZghQbx3_TgpRd"};